import { ApiClient } from "../ApiClient";

/**
 * Validate an address using Google Address Validation API via our backend
 * @param {string} url - The endpoint path
 * @param {Object} requestAddress - The address object to validate
 * @returns {Promise<Response>} The raw fetch response
 */
export const googleAddressValidate = async (url, requestAddress) => {
  // ApiClient.post handles baseUrl, JSON stringification, and headers.
  // Note: url is passed dynamically from the component.
  return ApiClient.post(url, requestAddress);
};
